import React, { useEffect } from 'react';
import withRouter from '../Components/Common/withRouter';

//redux
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import ApiService from '../admin/components/util/ApiService';

const NonAuthLayout = ({ children }) => {
    const nonauthData = createSelector(
        (state) => state.Layout,
        (layoutModeType) => layoutModeType.layoutModeType
      );
    // Inside your component
    const layoutModeType = useSelector(nonauthData);

    useEffect(() => {
        if (layoutModeType === "dark") {
            document.body.setAttribute("data-bs-theme", "dark");
        } else {
            document.body.setAttribute("data-bs-theme", "light");
        }
        return () => {
            document.body.removeAttribute("data-bs-theme")
        }
    }, [layoutModeType]);

    useEffect(() => {
        const domain = window.location.hostname;

        const carregarCustomizacoes = async () => {
            try {
                const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}custom-domain/get-css`, {}, false);
                const data = response?.data || response;

                if (!data) return;

                // Aplicar CSS customizado
                if (data.css) {
                    const styleElementoAnterior = document.getElementById('custom-domain-css');
                    if (styleElementoAnterior) {
                        styleElementoAnterior.remove();
                    }

                    const styleElement = document.createElement('style');
                    styleElement.id = 'custom-domain-css';
                    styleElement.innerHTML = data.css;
                    document.head.appendChild(styleElement);
                }

                // Armazenar dados no localStorage
                const imagens = {
                    logo: data.logo,
                    logoWhite: data.logoWhite,
                    smallLogo: data.smallLogo,
                    favicon: data.favicon,
                    loadingIcon: data.loadingIcon,
                    title: data.title,
                    titleFooter: data.titleFooter,
                    companyUrlFooter: data.companyUrlFooter,
                    logoLoginWidth: data.logoLoginWidth,
                    logoSidebarWidth: data.logoSidebarWidth,
                    logoSidebarSmWidth: data.logoSidebarSmWidth,
                    externalUserRegistration: data.externalUserRegistration,
                    customDomainId: data.customDomainId,
                    specialties: data.specialties || [],
                };
                localStorage.setItem(`custom_images_${domain}`, JSON.stringify(imagens));

                // Atualizar favicon
                if (data.favicon) {
                    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = data.favicon;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }

                // Atualizar título
                if (data.title) {
                    document.title = data.title;
                }

            } catch (error) {
                console.error('Erro ao carregar customizações:', error);
            }
        };

        carregarCustomizacoes();
    }, []);

    return (
        <div>
            {children}
        </div>
    );
};

export default withRouter(NonAuthLayout);